import LandingPage from "../LandingPage.jsx";

export default function LandingDe() {
  return <LandingPage forcedLang="de" />;
}